



























import { Component, Mixins, Ref } from "vue-property-decorator";
import CompanyMixin from "@/mixins/http/CompanyMixin";
import PoiCollapsibleList from "@/components/CompanyPlace/CollapsibleList.vue";
import PoiSearch from "@/components/CompanyPlace/Search.vue";
import { currentCompanyStore } from "@/store/typed";
import GenericCable from "@/cables/GenericCable";
import WrongExcelModal from "@/components/CompanyPlace/WrongExcelModal.vue";

@Component({ components: { PoiCollapsibleList, PoiSearch, WrongExcelModal } })
export default class Poi extends Mixins(CompanyMixin) {
  @Ref() readonly excelModal!: WrongExcelModal;
  cable: GenericCable | null = null;
  loading = false;

  mounted() {
    this.cable = new GenericCable("ClientPlacesChannel");
    this.cable.onResponse = this.onResponse;
    this.cable.open({ id: this.$route.params.id });
  }

  beforeDestroy() {
    this.cable?.close();
  }

  get companyPlaces() {
    return currentCompanyStore.companyPlaces;
  }

  get poiCount() {
    return this.companyPlaces?.length || 0;
  }

  back() {
    this.$router.push({
      name: "company_details",
      params: { id: this.$route.params.id },
    });
  }

  onResponse(data: any) {
    const companyPlace = this.$parseModel(data);
    if (companyPlace && data.status === 200) {
      currentCompanyStore.addOrReplace(companyPlace);
    } else if (data.status === 422) {
      if (companyPlace && companyPlace.id) {
        currentCompanyStore.removeCompanyPlace(companyPlace.id);
      } else {
        this.excelModal.show();
      }
    }
  }

  async onUpload(document: File) {
    this.loading = true;
    await this.uploadCompanyPlaces(this.$route.params.id, document);
    this.loading = false;
  }
}
